import _ from "lodash";

export default (value, defaultValue) => {
  try {
    return `${value}`.match(/-?\d*\.?\d+/g).map(Number);
  } catch (e) {
    return defaultValue ? _.castArray(defaultValue) : [];
  }
};
